// src/store/slices/leadsSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchLeads,
  addEmail,
  deleteEmail,
  addPerson,
  deletePerson,
  saveNotes,
  updateStatus,
  deleteLead,
  bulkEmailSend,
  updateLead,
  sendEmail,
} from "../thunks/leadsActions";

const initialState = {
  loading: false,
  leads: [],
  error: null,
  success: false,
};

const leadsSlice = createSlice({
  name: "leads",
  initialState,
  reducers: {
    resetLeadsState: (state) => {
      state.loading = false;
      state.leads = [];
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    // in extraReducers:
builder
  .addCase(updateLead.fulfilled, (state, { payload }) => {
    const idx = state.leads.findIndex(l => l._id === payload._id);
    if (idx >= 0) state.leads[idx] = payload;
  })

      // fetchLeads
      .addCase(fetchLeads.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLeads.fulfilled, (state, action) => {
        state.loading = false;
        state.leads = action.payload;
        state.error = null;
      })
      .addCase(fetchLeads.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || action.error.message;
      })

      // addEmail
      .addCase(addEmail.fulfilled, (state, { payload }) => {
        const lead = state.leads.find((l) => l._id === payload.leadId);
        if (lead) {
          lead.emails = lead.emails || [];
          lead.emails.push({ address: payload.address });
        }
      })

      // deleteEmail
      .addCase(deleteEmail.fulfilled, (state, { payload }) => {
        const lead = state.leads.find((l) => l._id === payload.leadId);
        if (lead)
          lead.emails = lead.emails.filter((e) => e.address !== payload.address);
      })

      // addPerson
      .addCase(addPerson.fulfilled, (state, { payload }) => {
        const lead = state.leads.find((l) => l._id === payload.leadId);
        if (lead) lead.people.push(payload.person);
      })

      // deletePerson
      .addCase(deletePerson.fulfilled, (state, { payload }) => {
        const lead = state.leads.find((l) => l._id === payload.leadId);
        if (lead)
          lead.people = lead.people.filter((p) => p.email !== payload.email);
      })

      // saveNotes
      .addCase(saveNotes.fulfilled, (state, { payload: updatedLead }) => {
    const idx = state.leads.findIndex(l => l._id === updatedLead._id);
    if (idx !== -1) {
      // replace the entire lead object (or merge just these fields)
      state.leads[idx].notes         = updatedLead.notes;
      state.leads[idx].notes_history = updatedLead.notes_history;
    }
  })
      // updateStatus
        // src/store/slices/leadsSlice.js
      .addCase(updateStatus.fulfilled, (state, { payload }) => {
        const lead = state.leads.find(l => l._id === payload.leadId)
        if (!lead) return
        lead.status = payload.status

        // schedule a 3-day follow-up whenever we mark 'contacted' or 'replied'
        if (payload.status === "contacted" || payload.status === "replied") {
          lead.next_follow_up = new Date(Date.now() + 3*24*60*60*1000)
        }
      })


      // deleteLead (soft delete)
      .addCase(deleteLead.fulfilled, (state, { payload }) => {
        const lead = state.leads.find((l) => l._id === payload);
        if (lead) lead.deleted = true;
      })

      // bulkEmailSend
      .addCase(bulkEmailSend.fulfilled, (state) => {
        state.success = true;
        state.error = null;
      })
      .addCase(bulkEmailSend.rejected, (state, action) => {
        state.error = action.payload?.message || action.error.message;
      })
      .addCase(sendEmail.fulfilled, (state, { payload }) => {
        const lead = state.leads.find((item) => item._id === payload.leadId);
        if (!lead || !payload.messageRecord) return;
        lead.messages = lead.messages || [];
        lead.messages.push(payload.messageRecord);
        lead.status = 'contacted';
      });
      
  },
});

export const leadsActions = leadsSlice.actions;
export default leadsSlice.reducer;
